export const FigmaPrototypeActions = () => {
    return {
        REDIRECT_TO_AV: () => {
            globalThis.open("https://www.figma.com/proto/gBL7H4J5MxtYCkmVjiPmTz/Altersvorsorge?page-id=3451%3A11075&node-id=3451-11112&viewport=-844%2C-2200%2C0.25&t=WnTdNAstE1W27SrN-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=3451%3A11112")
        },
        REDIRECT_TO_EKS: () => {
            globalThis.open("https://www.figma.com/proto/dbGdmJ7pyKThoLnE2vNnFO/Einkommenshutz?page-id=23%3A2037&node-id=23-6341&viewport=249%2C394%2C0.18&t=wAzYN2rQtdHOtHjb-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=23%3A6341")
        },
        REDIRECT_TO_HIBLI: () => {
            globalThis.open("https://www.figma.com/proto/jLPn0lkpI1GOKV9whDBU1k/Hinterbliebenen?page-id=3090%3A5024&node-id=3090-10261&viewport=2690%2C-2977%2C0.42&t=IzhRdQNxAyXAOW0Y-1&scaling=contain&content-scaling=fixed")
        },
        REDIRECT_TO_AV_PDF: () => {
            globalThis.open("/Altersvorsorge.pdf", "_blank")
        },
        REDIRECT_TO_EKS_PDF: () => {
            globalThis.open("/Einkommensschutz.pdf", "_blank")
        },
        REDIRECT_TO_HIBLI_PDF: () => {
            globalThis.open("/Hinterbliebene.pdf", "_blank")
        },
        REDIRECT_TO_AV_GBN: () => {
            globalThis.open("https://www.figma.com/proto/gBL7H4J5MxtYCkmVjiPmTz/Altersvorsorge?page-id=55%3A18172&node-id=167-1610&p=f&viewport=-1231%2C-1351%2C0.15&t=zUQArYpCxrjufF1f-1&scaling=min-zoom&content-scaling=fixed")
        },
        REDIRECT_TO_EKS_GBN: () => {
            globalThis.open("https://www.figma.com/proto/xV3TIXDh3D6NBs0P4vWUp6/Einkommenshutz?page-id=2182%3A8174&node-id=2182-8179&p=f&viewport=996%2C-145%2C0.24&t=UFdlvIknRr4YiMIa-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2182%3A8179")
        },
        REDIRECT_TO_HIBLI_GBN: () => {
            globalThis.open("https://www.figma.com/proto/jLPn0lkpI1GOKV9whDBU1k/Hinterbliebenen?page-id=302%3A15635&node-id=493-9456&p=f&viewport=1399%2C-807%2C0.14&t=2ZIB9VtHLqPcSlgM-1&scaling=scale-down&content-scaling=fixed")
        },
    }
}
